import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "c-modal",
  id: "modal-angebot-per-mail"
}
const _hoisted_2 = { class: "c-modal__content" }
const _hoisted_3 = { class: "c-modal__header" }
const _hoisted_4 = { class: "c-modal__title" }
const _hoisted_5 = { class: "c-modal__content-section u-text-align-left" }
const _hoisted_6 = {
  key: 0,
  class: "u-mar-b-1"
}
const _hoisted_7 = {
  key: 1,
  class: "o-grid"
}
const _hoisted_8 = { class: "o-grid__cell o-grid__cell--2 o-grid__cell--offset-8 form-actions u-mar-b-0 u-text-align-right" }
const _hoisted_9 = { class: "o-grid__cell o-grid__cell--2 form-actions u-mar-b-0 u-text-align-right" }
const _hoisted_10 = {
  key: 2,
  class: "o-grid"
}
const _hoisted_11 = { class: "o-grid__cell o-grid__cell--12 form-actions u-mar-b-0 u-text-align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _renderSlot(_ctx.$slots, "titel", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.modalTitel), 1)
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "c-button c-button--icon-only-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
        }, [
          _createVNode(_component_icon_sprite, { "icon-name": "icon-cross" }),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "c-button__visually-hidden" }, "close", -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_5, [
        (_ctx.modalText !== '' && !_ctx.verborgen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "text", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.modalText), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "inhalt", {
          closeModal: _ctx.closeModal,
          textVerbergenToggle: _ctx.textVerbergenToggle
        }),
        (_ctx.props.hatJaNeinButton === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "c-button",
                  type: "button",
                  "data-cy": "closeModalYes",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModalJa()))
                }, "Ja")
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "c-button",
                  type: "button",
                  "data-cy": "closeModalNo",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
                }, "Nein")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.props.hatSchliessenButton === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "c-button",
                  type: "button",
                  "data-cy": "closeModal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal()))
                }, _toDisplayString(_ctx.props.schliessenButtonText ? _ctx.props.schliessenButtonText : "OK"), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}